module.exports = __webpack_public_path__ + "static/img/lemon2_tr.8be20a12.png";